// extracted by mini-css-extract-plugin
module.exports = {"menu-container":"Menu_menu-container__5HLKB","open":"Menu_open__xF32e","close":"Menu_close__NnZQW"};